import { twMerge } from '@faceup/ui'
import type { ReactNode } from 'react'

type CircleIconProps = {
  icon: ReactNode
  color?: 'primary' | 'error'
}

export const CircleIcon = ({ icon, color = 'primary' }: CircleIconProps) => (
  <div
    className={twMerge(
      'flex h-[66px] w-[66px] items-center justify-center rounded-full text-colorWhite',
      color === 'primary' ? 'bg-colorPrimary' : 'bg-colorError'
    )}
  >
    {icon}
  </div>
)
